import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35c18fd4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=35c18fd4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c18fd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c18fd4')) {
      api.createRecord('35c18fd4', component.options)
    } else {
      api.reload('35c18fd4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35c18fd4&scoped=true", function () {
      api.rerender('35c18fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jdStore/samSrot/index.vue"
export default component.exports